import client from "./client";

const getLogoEncabezado = () => client.get("/logo-encabezado?populate=*");

export default {
  getLogoEncabezado,
};
